import { TableColumnConfigDto } from '@asset-metrix/portal-gateway-client-js';
import { CellClassParams } from 'ag-grid-community';

export const greenClass = 'ag-cell-pivot-color-green';
export const redClass = 'ag-cell-pivot-color-red';
export const rightAlignClass = 'ag-right-aligned-cell';
export const highlightClass = 'ag-cell-highlight';

export const getCellClassFunc =
  <TData, TValue>(
    columnConfig: TableColumnConfigDto,
    rowIdToHighlight?: string
  ) =>
  (params: Partial<CellClassParams<TData, TValue>>): string[] => {
    const classes: string[] = [];
    const pivotClass = getColorPivotClass(columnConfig, params.value);
    if (pivotClass != null) {
      classes.push(pivotClass);
    }
    if (columnConfig.align === 'right') {
      classes.push(rightAlignClass);
    }
    if (rowIdToHighlight && rowIdToHighlight === params.node?.id) {
      classes.push(highlightClass);
    }
    return classes;
  };

const getColorPivotClass = <TValue>(
  columnConfig: TableColumnConfigDto,
  value: TValue
) => {
  if (
    typeof value !== 'number' ||
    columnConfig.colorpivot == null ||
    columnConfig.type !== 'number'
  ) {
    return null;
  }

  let classes = [greenClass, redClass];
  if (columnConfig.invertColorpivot) {
    classes = classes.reverse();
  }
  if (value > columnConfig.colorpivot) {
    return classes[0];
  }
  if (value < columnConfig.colorpivot) {
    return classes[1];
  }
  return null;
};
